import classNames from "classnames"
import Block from "@/components/wrappers/block"
import styles from "./table.module.css"
import columns from "./columns.module.css"

export default function Table({ block, settings }) {
  const classes = [styles.table, block.attrs.classList]
  const { attrs } = block
  const { id, striped, valign, widths, fixedWidth } = attrs

  let width = settings?.width ?? "column"
  let gap = "content"

  if (block.attrs?.noStyling) {
    width = gap = null
  }

  if (widths && widths.length > 0) {
    const formattedWidths =
      (widths &&
        widths.map((width, index) => `column-${index + 1}-${width}`)) ||
      []
    classes.push(columns.cells)
    classes.push(formattedWidths)
  }

  return (
    <>
      <Style {...{ id, fixedWidth }} />
      <Block
        block={block}
        width={width}
        gap={gap}
        noStyling={block.attrs.noStyling}
        className={classNames(classes, "table__" + id, {
          "has-stripes": striped,
          "has-align-top": valign === "top",
          "has-align-bottom": valign === "bottom",
          "has-fixed-width": fixedWidth > 0
        })}
        innerHtml={block.html}
      />
    </>
  )
}

const Style = ({ id, fixedWidth }) => {
  if (!fixedWidth || fixedWidth === 0) {
    return null
  }

  const style =
    ".table__" + id + " .wp-block-table table { width: " + fixedWidth + "px; }"

  return <style>{style}</style>
}
